module.exports = __webpack_public_path__ + "static/portfolio-7-d0035df3500cb8870532cc0d8f136a76.jpg";